export default __webpack_public_path__ + "static/media/avatar_tapir3.9834cc4d.mp3";